import { render, staticRenderFns } from "./loginEmbedded.vue?vue&type=template&id=c339f232&"
import script from "./loginEmbedded.vue?vue&type=script&lang=js&"
export * from "./loginEmbedded.vue?vue&type=script&lang=js&"
import style0 from "./loginEmbedded.vue?vue&type=style&index=0&id=c339f232&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCol,VRow})
